import {RepositoryFactory} from '../../api/RepositoryFactory';

export default {
    actions: {
        GET_STUDENT_RESULTS: async (context, payload) => {
            await RepositoryFactory.get('results').getStudentResults(payload).then((res) => {
                context.commit('SET_RESULTS', res.data.results)
            });
        },

        GET_TEACHER_RESULTS: async (context, payload) => {
            await RepositoryFactory.get('results').getTeacherResults(payload).then((res) => {
                context.commit('SET_RESULTS', res.data.results)
            });
        },
    },

    mutations: {
        SET_RESULTS: (state, payload) => {
            state.results = payload;
        }
    },

    state: {
        results: []
    },

    getters: {
        RESULTS: state => {
            return state.results;
        }
    }
}